export default __webpack_public_path__ + "static/media/ant.dc6a9bb5.svg";